<div *ngIf="label" class="label text-grey24">{{ label }}</div>
<div *ngIf="hint" class="label text-grey60">{{ hint }}</div>
<ng-content></ng-content>
